module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-next-seo@1.11.0_gatsby@5.14.6_@babel+plugin-syntax-flow@7.27.1_@babel+cor_4ded5676db07527482eb8d7f3498dab5/node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-thumbor/gatsby-browser.js'),
      options: {"plugins":[],"breakpoints":[768,1280,1920]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.14.0_gatsby@5.14.6_@babel+plugin-syntax-flow@7.27.1_@_d94d9b4dac2cc32f685827b05dc904f9/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KWZFNV8","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.6_@babel+plugin-syntax-flow@7.27.1_@babel+core@7.28.0__@babel+plugin-transf_c02387cc632661eecb2f71937fddf8b7/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
